/**
 * Is the store in Quickshop mode?
 * @param  {Function} state    Redux state function
 * @return {Boolean} True, if in Quickshop mode; false, otherwise.
 */
export function isQuickshop(state) {
    return Boolean(state.quickshop) && Boolean(state.quickshop.isOpen);
}

/**
 * Is the product passed in eGiftCard and are we in a registry quickshop
 * @param  {Function} state    Redux state function
 * @param product product state
 * @return {Boolean} True, if in Quickshop mode and eGiftCard; false, otherwise.
 */
export function isEgiftCardRegistry(state, product) {
    return product.isEgiftCard && _.get(state, "quickshop.source") === "registry";
}
